<template>
  <v-dialog v-model="dialog" max-width="95%" transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark dense color="primary" elevation="0" tile class="mass-offers-toolbar">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Bulk Actions - Variants</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <div class="mass-offers">

        <v-subheader>Upload variants from CSV file.</v-subheader>

        <v-container class="px-0" fluid>
          <div class="text-left">
            <v-btn depressed :color="isUpdate ? '' : 'primary'" @click="isUpdate = !isUpdate; fileContent = []">ADD</v-btn>
            <v-btn depressed :color="isUpdate ? 'primary' : ''" @click="isUpdate = !isUpdate; fileContent = []">UPDATE</v-btn>
          </div>
          <label> choose template of CSV file for {{ isUpdate ? 'Update' : 'add' }} variants </label>
        </v-container>

        <v-row>
          <v-col cols="4">
            <v-file-input accept=".csv" :label="isUpdate ? 'Click here to select a .csv update file' : 'Click here to select a .csv for add file '" outlined v-model="chosenFile" class="mass-offer-input"></v-file-input>
          </v-col>
          <v-col cols="8">
            <v-btn elevation="0" color="primary" x-large @click="importCsv">
              <i class="fal fa-file-import mr-2"></i>
              Import file
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4"></v-col>
          <v-col cols="8" style="margin-top: -40px;">
            <a :href="isUpdate ? '../../batch_variants_update_sample.csv' : '../../batch_variants_add_sample.csv'">
              Download CSV Template ({{ isUpdate ? 'update' : 'add' }})
            </a>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <v-file-input accept="image/*" label="Attach previews" outlined v-model="previewFiles" multiple class="mass-offer-input"></v-file-input>
          </v-col>
          <v-col cols="8">
              <ul  v-if="previewFiles && previewFiles.length" style="list-style-type: none; padding: 0;margin: -6px">
                <li v-for="file in previewFiles" :key="file.name">{{ file.name }}</li>
              </ul>
          </v-col>
        </v-row>

        <label v-if="missingFiles().length > 0" style="color: red;">
          Missing Upload files
          <span class="count">{{ missingFiles().join(',') }}</span>
        </label>
        <v-spacer></v-spacer>
        <label>
          Count of selected records:
          <span class="count">{{ selected.length }}</span>
        </label>
        <v-spacer></v-spacer>
        <label>
          Count of all records:
          <span class="count">{{ fileContent.length }}</span>
        </label>
        <v-spacer></v-spacer>

        <v-data-table
            v-model="selected"
            :headers="isUpdate ? headersUpd : headers"
            :items="fileContent" show-select
            :item-key="isUpdate ? 'variantName' : 'variantName'"
            :single-select="singleSelect"
            class="elevation-1 offer-upload-grid">

          <template v-slot:item.extraParams="{ item }">
            <div :style="{ color: isInvalidFormat(item.extraParams) ? 'red' : 'black' }">{{ item.extraParams }}</div>
          </template>


        </v-data-table>

        <div class="loader-wrapper" v-if="loading">
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </div>

        <v-btn elevation="0" color="primary" @click="isUpdate ? updateVariantsDb() : insertVariantsDb()" style="margin-right: 10px">
          {{ isUpdate ? 'Update Selected Variants' : 'Add Selected Variants' }}
        </v-btn>
        <v-btn elevation="0" color="primary" @click="isUpdate ? updateVariantsDb(true) : insertVariantsDb(true)" style="margin-right: 10px">
          {{ isUpdate ? 'Update All Variants' : 'Add All Variants' }}
        </v-btn>
        <v-btn elevation="0" color="primary" @click="dialog = false">Close</v-btn>

        <ul id="successAdded">
          <h2>
            Success {{this.isUpdate? 'Updated' : 'Added'}} Count <span class="successAdded">{{ addedVariants.length }}</span>
          </h2>
          <li v-for="(addedVariant, index) in addedVariants" :key="index">
            {{ addedVariant.name }}
          </li>
        </ul>

        <ul id="successAddedFiles">
          <h2>
            Success Added files Count <span class="successAddedFiles">{{ addedFiles.length }}</span>
          </h2>
          <li v-for="(addedFile, index) in addedFiles" :key="index">
            {{ addedFile.name }}
          </li>
        </ul>

        <ul id="failedAdded">
          <h2>Failed Count <span class="failedAdded">{{ failedVariants.length }}</span></h2>
          <li v-for="(failedVariant, index) in failedVariants" :key="index">
            {{ failedVariant.error }}
          </li>
        </ul>


        <ul id="validation">
          <h2>
            Validation <span class="failedAdded">{{ validation.length }}</span>
          </h2>
          <thead v-if="validation.length !== 0">
          <tr>
            <th class="text-left" style="width: 400px;">
              Record
            </th>
            <th class="text-left">
              Variant Name
            </th>
            <th class="text-left">
              Empty Keys
            </th>
            <th class="text-left">
              Wrong Validation
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in validation" :key="index">
            <td>{{ item.record }}</td>
            <td>{{ item.variantName }}</td>
            <td>
              <div v-if="item.emptyKey.length !== 0">
                <div v-for="(key, ind) in item.emptyKey" :key="ind">
                  {{ key }}
                </div>
              </div>
            </td>
            <td>
              <div v-if="item.wrongValidation.length !== 0">
                <div v-for="([validation], ind) in item.wrongValidation" :key="ind">
                  {{ validation.key }} - {{ validation.value }}
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import csvParse from 'csv-parse';
import {mapGetters, mapState} from "vuex";
import offerVariants from "@/api/offerVariants";
import axios from "axios";
import store from "@/store";

export default {
  name: 'MassVariantsUpload',
  components: {},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'open',
    event: 'toggle',
  },
  async mounted() {
    this.dialog = this.open;
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('offers', ['getOffers']),
  },
  methods: {
    nullVariable() {
      this.loading = true;
      this.existsVariant = [];
      this.addedVariants = [];
      this.addedFiles = [];
      this.validation = [];
    },
    async alert() {
      await this.$dialog.info({
        text: `No records selected`,
        title: 'Validation Error'
      })
      this.loading = false;
    },
    isInvalidFormat(extraParams) {
      if (!extraParams) {
        return true;
      }

      try {
        const parsedParams = JSON.parse(extraParams);
        return Object.keys(parsedParams).length === 0 || Object.values(parsedParams).some(value => value.trim() === '');
      } catch (error) {
        return true;
      }
    },
    async updateVariantsDb(all) {
      this.nullVariable();
      try {
        this.failedVariants = [];
        const listOfRecordsToInsert = all ? this.fileContent : this.selected;
        if (listOfRecordsToInsert.length === 0) {
          await this.alert();
          return;
        }
        let count = 0;
        for (const variant of listOfRecordsToInsert) {
          const emptyKey = [];
          const validateData = [];
          const keys = Object.keys(variant);
          const ignoreKeys = ['extraParams','newExtraParams','newPreviewFilename'];
          keys.forEach((key) => {
            if (ignoreKeys.includes(key)) {
              return;
            }
            // if (Number(variant[key]) === 0) {
            //   emptyKey.push(key);
            // }
            const validateResp = this.validationCsv(key, variant[key]);
            if (validateResp && validateResp.length !== 0) {
              validateData.push(validateResp);
            }
          });
          count++;
          if (emptyKey.length !== 0 || validateData.length !== 0) {
            this.validation.push({
              record: count,
              variantName: variant.variantName,
              emptyKey,
              wrongValidation: validateData,
            });
            continue;
          }


          let variantParamsFormat
          if (variant.newExtraParams){
            variantParamsFormat = JSON.parse( variant.newExtraParams);
          }


          const params = [];
          for (const key in variantParamsFormat) {
            params.push({ name: key, value: variantParamsFormat[key] });
          }
          const updateResponse = await offerVariants.updateOfferVariant(
              null,
              variant.newVariantName ,
              variant.variantName,
              variant.newPreviewFilename,
              JSON.stringify(params),
              variant.isDefault,
              variant.offerId
          );

          if (updateResponse.success) {
            this.addedVariants.push({
              name: `name-${variant.variantName} offerId-${variant.offerId}`,
            });
            this.mapNamesIds.push({
              id: updateResponse.id,
              name: variant.newPreviewFilename
            })
          } else {
            this.failedVariants.push({
              error: `Failed to update variant ${variant.variantName} offerId ${variant.offerId} - ${updateResponse.message}`,
            });
          }
        }

        await this.importPreviewFiles();
        if (this.addedVariants.length === 0) {
          await this.$dialog.notify.error(`No variants updated`, {
            position: 'top-right',
            timeout: 1000
          })
        } else {
          await this.$dialog.notify.success(`Updated successfully ${this.addedVariants.length}`, {
            position: 'top-right',
            timeout: 1000
          })
        }

        this.loading = false;
      } catch (e) {
        console.log('updateVariantsDbError', e);
        this.failedVariants.push({
          error: `updateVariantsDbError:${e.toString()}`,
        });
        await this.$dialog.error({
          text: e.toString(),
          title: 'Failed variant'
        });
        this.loading = false;
      }
    },
    async insertVariantsDb(all) {
      // if (!this.offer.offer_id){
      //   await this.$dialog.error({
      //     text: 'Choose offer',
      //     title: 'Offer is empty'
      //   })
      //   return;
      // }

      this.nullVariable();
      try {
        this.failedVariants = [];
        const listOfRecordsToInsert = all ? this.fileContent : this.selected;
        if (listOfRecordsToInsert.length === 0) {
          await this.alert();
          return;
        }
        let count = 0;
        for (const variant of listOfRecordsToInsert) {
          const emptyKey = [];
          const validateData = [];
          const keys = Object.keys(variant);
          const ignoreKeys = ['extraParams'];
          keys.forEach((key) => {
            if (ignoreKeys.includes(key)) {
              return;
            }
            if (Number(variant[key]) === 0) {
              emptyKey.push(key);
            }
            const validateResp = this.validationCsv(key, variant[key]);
            if (validateResp && validateResp.length !== 0) {
              validateData.push(validateResp);
            }
          });
          count++;
          if (emptyKey.length !== 0 || validateData.length !== 0) {
            this.validation.push({
              record: count,
              variantName: variant.variantName,
              emptyKey,
              wrongValidation: validateData,
            });
            continue;
          }

          const newVariantResponse = await offerVariants.createOfferVariant(variant.offerId, variant.variantName);

          if (!newVariantResponse.success) {
            this.failedVariants.push({
              error: `Failed to create variant ${variant.variantName} offerId ${variant.offerId} - ${newVariantResponse.message}`,
            });
            continue;
          }
          let variantParamsFormat
          if (variant.extraParams){
            try {
              variantParamsFormat = JSON.parse( variant.extraParams);
            } catch (e) {
              throw new Error(`Failed to parse extraParams for variant ${variant.variantName} offerId ${variant.offerId} - ${e.message}`);
            }

          }


          const params = [];
          for (const key in variantParamsFormat) {
            params.push({ name: key, value: variantParamsFormat[key] });
          }
          const updateResponse = await offerVariants.updateOfferVariant(
              newVariantResponse.id,
              variant.variantName ,
              '',
              variant.previewFilename,
              JSON.stringify(params),
              Number(variant.isDefault),
              variant.offerId
          );

          if (updateResponse.success) {
            this.addedVariants.push({
              name: `name-${variant.variantName} offerId-${variant.offerId}`,
            });
            this.mapNamesIds.push({
              id:  newVariantResponse.id,
              name: variant.previewFilename
            })
          } else {
            this.failedVariants.push({
              error: `Failed to add variant ${variant.variantName} offerId ${variant.offerId} - ${updateResponse.message}`,
            });
          }
        }

        await this.importPreviewFiles();
        if (this.addedVariants.length === 0) {
          await this.$dialog.notify.error(`No variants updated`, {
            position: 'top-right',
            timeout: 1000
          })
        } else {
          await this.$dialog.notify.success(`Updated successfully ${this.addedVariants.length}`, {
            position: 'top-right',
            timeout: 1000
          })
        }
        this.loading = false;
      } catch (e) {
        console.log('insertVariantsDbError', e);
        this.failedVariants.push({
          error: `insertVariantsDbError:${e.toString()}`,
        });
        await this.$dialog.error({
          text: e.toString(),
          title: 'Failed variant'
        });
        this.loading = false;
      }
    },
    async importCsv() {
      try {
        if (!this.chosenFile) {
          await this.$dialog.info({
            text: `No file selected`,
            title: 'Validation Error'
          });
          return;
        }
        this.loading = true;
        this.filesCsv = [];
        const readFile = await this.processFile(this.chosenFile);
        const csvHeaders = readFile.split('\r')[0];
        if (this.isUpdate) {
          const requiredHeaders = ['Offer ID', 'Variant Name', 'New Variant Name', 'New Extra Params', 'New Preview Filename', 'is_default'];
          const missingHeaders = requiredHeaders.filter(header => !csvHeaders.includes(header));

          if (missingHeaders.length > 0) {
            await this.$dialog.error({
              text: `Wrong format for update csv, check template. Missing headers: ${missingHeaders.join(', ')}`,
              title: 'Validation Error'
            });
            this.loading = false;
            return;
          }
        } else {
          const expectedHeaders = ['Offer ID', 'Variant Name', 'Extra Params', 'Preview Filename', 'is_default'];
          const unexpectedHeaders = csvHeaders.split(',').filter(header => !expectedHeaders.includes(header.trim()));

          if (unexpectedHeaders.length > 0) {
            await this.$dialog.error({
              text: `Wrong format for create csv, check template. Unexpected headers found: ${unexpectedHeaders.join(', ')}`,
              title: 'Validation Error'
            });
            this.loading = false;
            return;
          }
        }
        const data = this.isUpdate ? await this.formatDataUpdate(readFile) : await this.formatData(readFile);

        data.shift();
        this.fileContent = data;
        if (this.isUpdate){
          this.fileContent.forEach((item) => {
            this.filesCsv.push(item.newPreviewFilename);
          });
        } else {
          this.fileContent.forEach((item) => {
            this.filesCsv.push(item.previewFilename);
          });
        }

        this.selected = [];
        this.existsVariant = [];
        this.validation = [];
        this.loading = false;
      } catch (e) {
        console.log('importCsvError', e);
        await this.$dialog.error({
          text: `error`,
          title: e.toString()
        });
        this.loading = false;
      }
    },
    async importPreviewFiles() {
      if (!this.isUpdate && (!this.previewFiles || !this.previewFiles.length)) {
        await this.$dialog.info({
          text: `No preview files selected`,
          title: 'Validation Error'
        });
        return;
      }

      let successCount = 0;

      for (const file of this.previewFiles) {
        const extension = file.name.split('.').pop();
        const matchedEntries = this.mapNamesIds.filter(entry => entry.name === file.name);

        if (matchedEntries.length === 0) {
          this.validation.push({
            record: 'Preview',
            variantName: file.name,
            emptyKey: ['No matching entry found'],
            wrongValidation: [],
          });
          console.warn(`No matching entry found for file: ${file.name}`);
          continue;
        }

        for (const matchedEntry of matchedEntries) {
          const { id } = matchedEntry;

          try {
            console.log('Uploading file:', file);
            const presignedURL = await offerVariants.offerVariantImageUploadUrl(
                id,
                file.name,
                extension,
                'PUT'
            );
            console.log('presignedURL successfully created :', presignedURL);
            await axios.put(presignedURL, file, {
              headers: {
                'Content-Type': file.type,
              },
            });

            const imageUrl = await offerVariants.offerVariantImageUploadUrl(
                id,
                file.name,
                extension,
                'GET'
            );
            console.log('File uploaded imageUrl:', imageUrl);
            this.addedFiles.push({
              name: `UPLOAD FILE SUCCESS name-${file.name} offerId-${id}`,
            });
            successCount++;
          } catch (error) {
            console.error('Error uploading file:', error);
            this.validation.push({
              record: 'Preview',
              variantName: file.name,
              emptyKey: ['Failed to upload file'],
              wrongValidation: [],
            });
          }
        }
      }

      const message = `${successCount} files were uploaded successfully`;
      if (successCount === 0) {
        await this.$dialog.notify.error('No files were uploaded', {
          position: 'top-right',
          timeout: 1000
        })
      } else {
        await this.$dialog.notify.success(message, {
          position: 'top-right',
          timeout: 1000
        })
        console.log(message);
      }


    },

    async formatData(dataFile) {
      const csvHeaders = dataFile.split('\r')[0];
      const csvHeadersArray = csvHeaders.split(',');
      const headersMap = {};
      csvHeadersArray.forEach((i, index) => {
        headersMap[i] = index;
      });
      return new Promise((resolve, reject) => csvParse(
          dataFile,
          {},
          (err, output) => (err ? reject(err) : resolve(output.map((record) => ({
            offerId: record[headersMap['Offer ID']] && record[headersMap['Offer ID']].trim(),
            variantName: record[headersMap['Variant Name']] && record[headersMap['Variant Name']].trim(),
            extraParams: record[headersMap['Extra Params']] && record[headersMap['Extra Params']].trim(),
            previewFilename: record[headersMap['Preview Filename']] && record[headersMap['Preview Filename']].trim(),
            isDefault: record[headersMap['is_default']] && record[headersMap['is_default']].trim(),
          })))),
      ));
    },
    async formatDataUpdate(dataFile) {
      const csvHeaders = dataFile.split('\r')[0];
      const csvHeadersArray = csvHeaders.split(',');
      const headersMap = {};
      csvHeadersArray.forEach((i, index) => {
        headersMap[i] = index;
      });
      return new Promise((resolve, reject) => csvParse(
          dataFile,
          {},
          (err, output) => (err ? reject(err) : resolve(output.map((record) => ({
            offerId: record[headersMap['Offer ID']] && record[headersMap['Offer ID']].trim(),
            variantName: record[headersMap['Variant Name']] && record[headersMap['Variant Name']].trim(),
            newVariantName: record[headersMap['New Variant Name']] && record[headersMap['New Variant Name']].trim(),
            newExtraParams: record[headersMap['New Extra Params']] && record[headersMap['New Extra Params']].trim(),
            newPreviewFilename: record[headersMap['New Preview Filename']] && record[headersMap['New Preview Filename']].trim(),
            isDefault: record[headersMap['is_default']] && record[headersMap['is_default']].trim(),
          })))),
      ));
    },
    async parse(file) {
      const reader = new FileReader();
      reader.readAsText(file);
      return await new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve(reader.result);
        };
      });
    },
    validationCsv(key, value) {
      const validation = [];
      switch (key) {
        case 'variantName': {
          if (!value) {
            validation.push({ key, value });
          }
          break;
        }
        case 'extraParams': {

          if (value && value.trim() !== '') {
            try {
              JSON.parse(value);
            } catch (e) {
              validation.push({ key, value });
            }
          }
          break;
        }
        default:
      }
      return validation;
    },
    async processFile(file) {
      try {
        return await this.parse(file);
      } catch (e) {
        console.log('processFileError:', e);

        await this.$dialog.error({
          text: `error`,
          title: e.toString()
        });
      }
    },
    missingFiles(){
      const previewFileNames = this.previewFiles.map(file => file.name);
      return this.filesCsv.filter(fileName => fileName && !previewFileNames.includes(fileName));
    }
  },
  data() {
    return {
      mapNamesIds: [],
      dialog: this.open,
      loading: false,
      chosenFile: null,
      previewFiles: [],
      fileContent: [],
      offer: {},
      data: null,
      selected: [],
      filesCsv: [],
      existsVariant: [],
      validation: [],
      singleSelect: false,
      isUpdate: false,
      radios: false,
      addedVariants: [],
      addedFiles: [],
      failedVariants: [],
      headers: [
        { text: 'Offer ID', value: 'offerId' },
        { text: 'Variant Name', value: 'variantName' },
        { text: 'Extra Params', value: 'extraParams' },
        { text: 'Preview Filename', value: 'previewFilename', align: 'center'},
        { text: 'Default', value: 'isDefault',  align: 'center' },
      ],
      headersUpd: [
        { text: 'Offer ID', value: 'offerId' },
        { text: 'Variant Name', value: 'variantName' },
        { text: 'New Variant Name', value: 'newVariantName' },
        { text: 'New Extra Params', value: 'newExtraParams' },
        { text: 'New Preview Filename', value: 'newPreviewFilename' },
        { text: 'Default', value: 'isDefault', align: 'center' },
      ],
    };
  },
  watch: {
    dialog() {
      this.$emit('toggle', this.dialog);
    },
    open() {
      this.dialog = this.open;
    },
  },
};
</script>

<style lang="sass">
.offer-upload-grid
  .v-data-table__wrapper
    height: 40vh
    overflow: auto

.mass-offers-toolbar
  padding: 0px 20px

.mass-offers
  padding: 20px

.v-data-footer
  margin-bottom: 20px

.v-input.mass-offer-input.v-text-field--outlined > .v-input__control > .v-input__slot
  min-height: 52px !important

.v-input.mass-offer-input.v-text-field > .v-input__control > .v-input__slot
  cursor: pointer

span.count
  background-color: transparent !important
  color: var(--v-primary-base) !important
  font-size: inherit
  font-weight: 600

span.successAdded
  background-color: transparent !important
  color: var(--v-success-base) !important
  font-size: inherit

span.successAddedFiles
  background-color: transparent !important
  color: var(--v-success-base) !important
  font-size: inherit

span.failedAdded
  background-color: transparent !important
  color: var(--v-error-base) !important
  font-size: inherit

ul#successAdded li, ul#failedAdded li
  margin-left: 30px

ul#successAddedFiles li, ul#failedAdded li
  margin-left: 30px
</style>
